import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReferenceBox from '../../common/reference-box';
import articleTagsService from '../../../services/article-tags/article-tags';
import formattersService from '../../../services/formatters';
import './daily-news-article-box.css';

class DailyNewsArticleBox extends Component {
  render() { 
    const relevantTags = articleTagsService.getRelevantRecommendationsTags(this.props.tags);

    return (
      <div className='daily-news-article-box little-grow-animation'>
        <ReferenceBox 
          _id={this.props._id}
          title={this.props.title}
          postTime={formattersService.formatDate(this.props.date)}
          link={`/daily-news/${this.props.internalUrlId}`}
          imgSrc={this.props.imgUrl}
          writer={this.props.writer}
          publication={this.props.publication}
          tags={relevantTags}          
          buffText={this.props.buffText}
          isTitleTagH4={false} />
      </div>
    );
  }
}

DailyNewsArticleBox.propTypes = {
  _id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  internalUrlId: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
  date: PropTypes.string,
  writer: PropTypes.string, 
  publication: PropTypes.string,
  buffText: PropTypes.string
};

export default DailyNewsArticleBox;